import { GetRequestOptions } from "./grunt";

const Pth=process.env.REACT_APP_GRUNT_API+"/mrgg";
const StatusOk={status:200};

const getPopise=async(_zivbr="")=>{
    let _pth=Pth+"/popis";
    if (_zivbr!=="") {
        _pth=_pth+"?likezivbr="+_zivbr;
    }
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res.Popis;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getPopiseBySpecId=async(_specids)=>{
    
    try {
        const r = await fetch(Pth+`/popis/specifikacija/${_specids.toString().replaceAll(',','_')}`, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res.Popis;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
///popis/govedazaspecifikaciju/:rggids
const getPopisGovedaZaSpecifikaciju=async(_rggids=null,_specid=null)=>{
    let _pth="";
    if (_rggids!==null) {
        _pth=Pth+`/popis/govedazaspecifikaciju/${_rggids.toString().replaceAll(',','_')}`
    } else {
        _pth=Pth+`/popis/govedazaspecifikaciju/specifikacija/${_specid}`
    }
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res.Popis;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
const getPopisData=async(rggid)=>{
    
    try {
        const r = await fetch(Pth+`/popis/goveda/${rggid}`, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res.PopisData;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

//popis/goveda/item/:popisgovedoitemid"
const getPopisGovedoData=async(popisgovedoid)=>{
    
    try {
        const r = await fetch(Pth+`/popis/goveda/item/${popisgovedoid}`, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            if (res.PopisGovedoData.length>0) {
                StatusOk.res=res.PopisGovedoData[0];
            } else {
                StatusOk.res=null;
            }
            
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updatePopisGovedoItem=async(_popisgovedoid,_zivbr,_rfid,_spol,_pasminasifra,_boksid,_updatergg=false)=>{
    const _data={
        popisgovedoid:_popisgovedoid,
        zivbr:_zivbr,
        rfid:_rfid,
        spol:_spol,
        pasminasifra:_pasminasifra,
        boksid:_boksid
    };
    try {
        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body = JSON.stringify(_data);
        ///popis/goveda/item/rgg/update
        let _pth=Pth+`/popis/goveda/item/update`;
        if (_updatergg) {
            _pth=Pth+`/popis/goveda/item/rgg/update`;
        } 

        
        const r = await fetch(_pth, _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res="ok";
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ažuriranja podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
///popis/goveda/xlsx/:rggid
// res=await r.arrayBuffer();
const getPopisGovedoXlsx=async(rggid)=>{
    try {
        const r = await fetch(Pth+`/popis/goveda/xlsx/${rggid.toString()}`, GetRequestOptions("GET"));    
        const res=await r.arrayBuffer();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateUkljuciUPopis=async (_popisgovid,_ukljuci)=>{
    ///popis/:popisgovedoid/:ukljuciupopis
    try {
        const r = await fetch(Pth+`/popis/${_popisgovid}/${_ukljuci.toString()}`, GetRequestOptions("PUT"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res="ok";
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ažuriranja podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
///popis/popisgovedo/:popisgovedoid
const deletePopisGovedo=async (_popisgovid)=>{
    
    try {
        const r = await fetch(Pth+`/popis/popisgovedo/${_popisgovid}`, GetRequestOptions("DELETE"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res="ok";
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod brisanja podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const deletePopis=async (_rggid)=>{
    
    try {
        const r = await fetch(Pth+`/popis/${_rggid}`, GetRequestOptions("DELETE"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res="ok";
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod brisanja podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}


export {
   getPopise,getPopisData,updateUkljuciUPopis,getPopisGovedoData,updatePopisGovedoItem,getPopisGovedoXlsx,
   getPopiseBySpecId,getPopisGovedaZaSpecifikaciju,deletePopisGovedo,deletePopis
};

